"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var CropRotate = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M7,7 L7,5 L8,5 L8,7 L14,7 C15.6568542,7 17,8.34314575 17,10 L17,16 L19,16 L19,17 L17,17 L17,19 L16,19 L16,17 L10,17 C8.34314575,17 7,15.6568542 7,14 L7,8 L5,8 L5,7 L7,7 Z M16,16 L16,10 C16,8.8954305 15.1045695,8 14,8 L8,8 L8,14 C8,15.1045695 8.8954305,16 10,16 L16,16 Z M22.8618505,10.6 L23.9624116,10.6 C23.356556,4.6108387 18.3068092,0 12.2316398,0 C12.1624456,0 12.0936736,0.00181975924 12.0200005,0.00551793594 L15.3816398,3.36715729 L16.6699086,2.07888848 L16.7973046,2.13927495 C20.1355157,3.72160742 22.4450195,6.90965564 22.8618505,10.6 Z M11.934008,23.9952496 L8.5811185,20.6335599 L7.29274785,21.9316175 L7.16465805,21.8705105 C3.82514471,20.2773481 1.51720911,17.0886637 1.10056272,13.3999996 L0,13.3999996 C0.605857095,19.3891609 5.65560391,23.9999996 11.7307733,23.9999996 C11.7987067,23.9999996 11.8581706,23.9986706 11.934008,23.9952496 Z" })));
};
CropRotate.displayName = 'CropRotate';
exports.default = CropRotate;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CropRotate.js.map